// extracted by mini-css-extract-plugin
export var divider = "_19-0";
export var dividerText = "_19-1";